import React, { useRef, useState } from 'react';
import WavesurferPlayer, { useWavesurfer } from '@wavesurfer/react';
import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const WaveSurferComponent = ({ audioUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false); // Track the playing state
  const audioRef = useRef(null); // Reference to the audio element

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause(); // Pause audio
    } else {
      audioRef.current.play(); // Play audio
    }
    setIsPlaying(!isPlaying); // Toggle the state
  };

  //   const [wavesurfer, setWavesurfer] = useState(null);
  //   const [isPlaying, setIsPlaying] = useState(false);

  //   //   const { wavesurfer, isPlaying } = useWavesurfer({
  //   //     container: containerRef,
  //   //     url: audioUrl,
  //   //     waveColor: '#000',
  //   //     height: 100,
  //   //     barWidth: 3,
  //   //     cursorWidth: 2,
  //   //     backend: 'WebAudio',
  //   //     progressColor: '#2D5BFF',
  //   //     responsive: true,
  //   //     cursorColor: 'transparent',
  //   //     barGap: 2,
  //   //     barRadius: 10,
  //   //   });

  //   const onReady = (ws) => {
  //     setWavesurfer(ws);
  //     setIsPlaying(false);
  //   };

  //   const onPlayPause = () => {
  //     wavesurfer && wavesurfer.playPause();
  //     console.log();
  //   };

  return (
    <div style={{ position: 'relative' }}>
      {/* <WavesurferPlayer
        height={100}
        waveColor="black"
        url={audioUrl}
        onReady={onReady}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      />{' '} */}
      <audio ref={audioRef} src={audioUrl} controls />

      {/* <button onClick={onPlayPause} id="wavePlayerBtn"> */}
      {/* <button onClick={togglePlay} id="wavePlayerBtn">
        <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
      </button> */}
    </div>
  );
};

export default WaveSurferComponent;
